import { render, staticRenderFns } from "./upvote.vue?vue&type=template&id=07ed9764&scoped=true&"
import script from "./upvote.vue?vue&type=script&lang=js&"
export * from "./upvote.vue?vue&type=script&lang=js&"
import style0 from "./upvote.vue?vue&type=style&index=0&id=07ed9764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed9764",
  null
  
)

export default component.exports